import {
    Box,
    BoxProps,
    Grid,
    GridProps,
    Chip,
    FormControl,
    Autocomplete,
    TextField,
    MenuItem,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
    FormControlProps,
    Button,
    ButtonProps,
    CircularProgress,
    useTheme,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import React, { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import * as Styles from "./userDetails.styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as userService from "services/user-service";
import * as applicationService from "services/application-service";
import * as departmentService from "services/department-service";
import * as certificateService from "services/certificate-service";
import { UserApplicationDto, UserCertificateDto } from "services/user-service";

import { statusStyleCertificate } from "utilities/colorHelper";
import dayjs from "dayjs";
import { AxiosError } from "axios";
import Collapse from "components/formsUI/Collapse/Collapse";
import OutOfServiceModal from "pages/employee/users/userDetails/modals/outOfService.modal";

const UserDetails = () => {
    const { userId } = useParams();
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [loadRequests, setLoadRequests] = useState<boolean>(false);
    const [loadCertificates, setLoadCertificates] = useState<boolean>(false);
    const [user, setUser] = useState<userService.UserDto | null>(null);
    const [applications, setApplications] = useState<UserApplicationDto[]>([]);
    const [certificates, setCertificates] = useState<UserCertificateDto[]>([]);
    const [departments, setDepartments] = React.useState<string[]>([]);
    const [orgnisationDisabled, setOrgnisationDisabled] =
        React.useState<boolean>(false);

    const [canRenew, setCanRenew] = useState<boolean>(false);

    const [openOOS, setOpenOOS] = useState<boolean>(false);
    const handleOpenOOS = (): void => {
        setOpenOOS(true);
    };

    const handleCloseOOS = (): void => {
        setOpenOOS(false);
    };

    const navigateToCertificate = (certificateId: string): void => {
        navigate(`/beheer/attesten/${certificateId}`);
    };

    const navigateToApplication = (applicationId: string): void => {
        navigate(`/beheer/aanvragen/${applicationId}`);
    };

    const renewCertificate = (): void => {
        if (user && user.latestCertificate) {
            navigate(`/beheer/vernieuwingen/${user.latestCertificateId}`);
            // applicationService
            //     .getApplicationWithDetails(
            //         user.latestCertificate.application.id,
            //     )
            //     .then((resp: ApplicationWithDetails) => {
            //         if (user.latestCertificate !== null) {
            //             certificateService
            //                 .renewCertificate(user.latestCertificate.id, resp)
            //                 .then((data: Application) => {
            //                     navigate("/beheer/aanvragen/" + data.id);
            //                 });
            //         }
            //     });
        }
    };

    const getStatus = (certificate: CertificateWithDetails) => {
        const dateToday = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
        );
        // const outOfServiceDate = dayjs(
        //     certificate.application.applicant.outOfServiceDate,
        // ).startOf("day");

        if (certificate.isRevoked) {
            return "Ingetrokken";
        } else if (
            !certificate.isRevoked &&
            new Date(certificate.application.dateTo) < dateToday
        ) {
            return "Verlopen";
        } else if (
            certificate.isApproved &&
            !certificate.isRevoked &&
            new Date(certificate.application.dateFrom) > dateToday
        ) {
            return "Toekomstig geldig";
        } else if (
            certificate.isApproved &&
            !certificate.isRevoked &&
            new Date(certificate.application.dateFrom) <= dateToday &&
            new Date(certificate.application.dateTo) >= dateToday
        ) {
            return "Geldig";
        } else if (!certificate.isApproved && !certificate.isRevoked) {
            return "Goed te keuren";
        }
        return "";
    };

    const fetchData = (): void => {
        if (userId !== null && userId !== undefined) {
            userService.getById(userId).then((data) => {
                if (data.latestCertificate) {
                    certificateService
                        .validateRenewals([data.latestCertificate.id])
                        .then((renewalStatuses) => {
                            setCanRenew(
                                renewalStatuses.length === 1 &&
                                    renewalStatuses[0] ===
                                        data.latestCertificate?.id,
                            );
                        });
                    data.latestCertificate.status = getStatus(
                        data.latestCertificate,
                    );
                }
                setUser(data);
            });
        }
    };

    useEffect(() => {
        if (userId !== null && userId !== undefined) {
            fetchData();
        }
        if (departments.length <= 0) {
            departmentService
                .getDepartmentNames()
                .then((res: string[]) => {
                    setDepartments([...res]);
                })
                .catch((error: AxiosError<Error>) => {
                    // showError(`${t("certificateWithDetail.errorServer")}`);
                });
        }
    }, [userId, departments]);

    const changeDepartment = (event: any, newValue: string | null) => {
        // setErrorMessage("");
        // setShowErrorMessage(false);
        console.log(newValue);
        if (userId && (newValue || newValue === "")) {
            userService
                .changeDepartment({
                    userId: userId,
                    departmentName: newValue,
                })
                .then(() => {
                    fetchData();
                });
            // applicationService
            //     .updateApplicationDepartment(
            //         user.latestCertificate.application.id,
            //         newValue,
            //     )
            //     .then((res: ApplicationWithDetails) => {
            //         if (
            //             user &&
            //             user.latestCertificate &&
            //             user.latestCertificate.application
            //         ) {
            //             const temp = {
            //                 ...user.latestCertificate.application,
            //                 department: res.department,
            //                 status: res.status,
            //                 statusHistories: res.statusHistories,
            //             };
            //             // setRequest(temp);
            //             setUser({
            //                 ...user,
            //                 latestCertificate: {
            //                     ...user.latestCertificate,
            //                     application: temp,
            //                 },
            //             });
            //         }
            //     })
            //     .catch((error: AxiosError<Error>) => {
            //         // showError(`${t("requestWithDetail.errorServerUpdate")}`);
            //     });
        }
    };

    const retrieveApplications = (open: boolean): void => {
        if (open) {
            setLoadRequests(true);
            userService.getUserApplications(userId || "").then((data) => {
                setApplications(data);
                setLoadRequests(false);
            });
        } else {
            setApplications([]);
        }
    };

    const retrieveCertificates = (open: boolean): void => {
        if (open) {
            setLoadCertificates(true);
            userService.getUserCertificates(userId || "").then((data) => {
                setCertificates(data);
                setLoadCertificates(false);
            });
        } else {
            setCertificates([]);
        }
    };

    const wrapper: BoxProps = {
        sx: Styles.wrapper(theme),
    };

    const statuswrapper: GridProps = {
        sx: Styles.statusWrapper(theme),
    };

    const collapseGridContainer: GridProps = {
        container: true,
        item: true,
        spacing: 2,
        md: 12,
        xs: 12,
        justifyContent: "center",
        sx: {
            marginLeft: "0.75rem",
            marginBottom: "0.75rem",
        },
    };

    const selectProcessorWrapper: BoxProps = {
        sx: Styles.selectProcessorWrapper(theme),
    };

    const selectProcessor: FormControlProps = {
        sx: Styles.selectProcessor(theme),
    };

    const statusButton: ButtonProps = {
        sx: Styles.statusButton(theme),
        variant: "contained",
    };

    return (
        <Box {...wrapper}>
            <Box sx={{ padding: "15px" }}>
                <h1 style={{ marginTop: "0" }}>
                    <ArrowBackIcon
                        sx={{
                            padding: "0",
                            fontSize: "25px",
                            marginRight: "5px",
                            "&:hover": { cursor: "pointer" },
                        }}
                        onClick={() => navigate(-1)}
                    />
                    {t("userDetail.title")} - {user?.voornaam} {user?.naam}
                </h1>
                {user !== null && (
                    <Box>
                        <Box>
                            <Grid container {...statuswrapper}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        mb: { xs: "10px", sm: 0 },
                                        alignSelf: "center",
                                    }}
                                >
                                    <Box>
                                        <b>
                                            {t("userDetail.certificate.status")}
                                        </b>
                                        {user?.latestCertificate !== null && (
                                            <Chip
                                                sx={{
                                                    marginLeft: "10px",
                                                    backgroundColor:
                                                        statusStyleCertificate(
                                                            user
                                                                ?.latestCertificate
                                                                ?.status || "",
                                                        ),
                                                    color: "white",
                                                }}
                                                label={t(
                                                    user?.latestCertificate
                                                        ?.status || "",
                                                )}
                                            />
                                        )}
                                        <br />
                                        <Box>
                                            <b>
                                                {t(
                                                    "userDetail.certificate.endDate",
                                                )}
                                            </b>
                                            <span> </span>
                                            <span>
                                                {user?.latestCertificate
                                                    ?.application?.dateTo
                                                    ? dayjs(
                                                          user
                                                              ?.latestCertificate
                                                              ?.application
                                                              ?.dateTo,
                                                      ).format("DD/MM/YYYY")
                                                    : ""}
                                            </span>
                                        </Box>
                                        <Box {...selectProcessorWrapper}>
                                            <Box minWidth={100}>
                                                <b>
                                                    {t(
                                                        "requestsTableHeader.department",
                                                    )}
                                                </b>
                                            </Box>
                                            <FormControl
                                                {...selectProcessor}
                                                size="small"
                                            >
                                                <Box>
                                                    <Autocomplete
                                                        sx={{
                                                            backgroundColor:
                                                                "white",
                                                        }}
                                                        options={departments}
                                                        value={
                                                            user?.department
                                                                ?.name
                                                        }
                                                        // disabled={request.status === "Geweigerd" || request.status === "Gunstig" || orgnisationDisabled}
                                                        disabled={
                                                            orgnisationDisabled
                                                        }
                                                        onChange={(
                                                            event: any,
                                                            value:
                                                                | string
                                                                | null,
                                                        ) => {
                                                            changeDepartment(
                                                                event,
                                                                value,
                                                            );
                                                        }}
                                                        renderInput={(
                                                            params,
                                                        ) => (
                                                            <TextField
                                                                {...params}
                                                                sx={{
                                                                    width: "150px",
                                                                }}
                                                                size="small"
                                                            />
                                                        )}
                                                        renderOption={(
                                                            props,
                                                            option,
                                                        ) => (
                                                            <MenuItem
                                                                {...props}
                                                                key={option}
                                                                value={option}
                                                            >
                                                                {option === ""
                                                                    ? "Geen departement"
                                                                    : option}
                                                            </MenuItem>
                                                        )}
                                                        clearIcon={
                                                            <ClearIcon
                                                                fontSize="small"
                                                                onClick={() => {
                                                                    changeDepartment(
                                                                        null,
                                                                        "",
                                                                    );
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </Box>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        textAlign: {
                                            sm: "end",
                                            alignSelf: "center",
                                        },
                                    }}
                                    columnSpacing={1}
                                >
                                    <Box>
                                        {canRenew && (
                                            <Button
                                                {...statusButton}
                                                color="success"
                                                onClick={renewCertificate}
                                            >
                                                {t("userDetail.renewCertificate")}
                                            </Button>
                                        )}
                                    </Box>
                                    <Box>
                                        {user?.actief &&
                                            (user.pnummer === undefined ||
                                                user.pnummer === null) &&
                                            (user.stamnummer === undefined ||
                                                user.stamnummer === null) && (
                                                <Button
                                                    {...statusButton}
                                                    color="warning"
                                                    onClick={handleOpenOOS}
                                                >
                                                    {t("userDetail.OOS")}
                                                </Button>
                                            )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Collapse
                                defaultOpen
                                title={t("userDetail.details")}
                            >
                                <Grid {...collapseGridContainer}>
                                    <Grid item xs={3}>
                                        <div>
                                            <span>
                                                {t("userDetail.firstName")}
                                            </span>
                                            <br />
                                            <b>{user?.voornaam}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <div>
                                            <span>{t("userDetail.name")}</span>
                                            <br />
                                            <b>{user?.naam}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div>
                                            <span>{t("userDetail.rrn")}</span>
                                            <br />
                                            <b>{user?.rijksregisternummer}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <div>
                                            <span>
                                                {t("userDetail.nationaliteit")}
                                            </span>
                                            <br />
                                            <b>{user?.nationaliteit}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div>
                                            <span>
                                                {t("userDetail.Stamnummer")}
                                            </span>
                                            <br />
                                            <b>{user?.stamnummer}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <div>
                                            <span>
                                                {t("userDetail.pnummer")}
                                            </span>
                                            <br />
                                            <b>{user?.pnummer}</b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <InfoIcon />
                                            <span>
                                                {t("userDetail.disclaimer")}
                                            </span>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div>
                                            <span>
                                                {t("userDetail.dateOfBirth")}
                                            </span>
                                            <br />
                                            <b>
                                                {user.latestCertificate &&
                                                    dayjs(
                                                        user?.latestCertificate
                                                            ?.application
                                                            ?.applicant
                                                            ?.birthDay,
                                                    ).format("DD/MM/YYYY")}
                                            </b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div>
                                            <span>{t("userDetail.adres")}</span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.street
                                                }{" "}
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.houseNumber
                                                }{" "}
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.box
                                                }
                                                <br />
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.zip
                                                }{" "}
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.city
                                                }
                                                <br />
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.address?.country
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div>
                                            <span>{t("userDetail.email")}</span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application?.applicant
                                                        ?.email
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Collapse>
                            <Collapse
                                defaultOpen
                                title={t("userDetail.certificate.details")}
                            >
                                <Grid {...collapseGridContainer}>
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <InfoIcon />
                                            <span>
                                                {t("userDetail.disclaimer")}
                                            </span>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div>
                                            <span>
                                                {t(
                                                    "userDetail.responsible.company",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application
                                                        ?.responsible?.company
                                                        ?.name
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <div>
                                            <span>
                                                {t(
                                                    "userDetail.responsible.email",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application
                                                        ?.responsible?.email
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div>
                                            <span>
                                                {t(
                                                    "userDetail.responsible.firstName",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application
                                                        ?.responsible?.firstName
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <div>
                                            <span>
                                                {t(
                                                    "userDetail.responsible.lastName",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {
                                                    user?.latestCertificate
                                                        ?.application
                                                        ?.responsible?.lastName
                                                }
                                            </b>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Collapse>

                            <Collapse
                                defaultOpen={false}
                                title={t("userDetail.applications")}
                                onToggle={retrieveApplications}
                            >
                                {loadRequests && (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <CircularProgress />
                                    </Box>
                                )}
                                {!loadRequests && (
                                    <TableContainer component={Box}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.reference",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.startDate",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.endDate",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.status",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {applications.map(
                                                    (application) => (
                                                        <TableRow
                                                            key={application.id}
                                                        >
                                                            <TableCell
                                                                component="th"
                                                                scope="row"
                                                            >
                                                                <Link
                                                                    component="button"
                                                                    variant="body2"
                                                                    onClick={() => {
                                                                        navigateToApplication(
                                                                            application.id,
                                                                        );
                                                                    }}
                                                                >
                                                                    {
                                                                        application.referenceCode
                                                                    }
                                                                </Link>
                                                            </TableCell>
                                                            <TableCell>
                                                                {dayjs(
                                                                    application.dateFrom,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {dayjs(
                                                                    application.dateTo,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {t(
                                                                    application.status,
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ),
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Collapse>

                            <Collapse
                                defaultOpen={false}
                                title={t("userDetail.certificates")}
                                onToggle={retrieveCertificates}
                            >
                                {loadCertificates && (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <CircularProgress />
                                    </Box>
                                )}
                                {!loadCertificates && (
                                    <TableContainer component={Box}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.reference",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.startDate",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.endDate",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                    <TableCell>
                                                        <b>
                                                            {t(
                                                                "userDetail.table.status",
                                                            )}
                                                        </b>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {certificates.map(
                                                    (certificate) => (
                                                        <TableRow
                                                            key={certificate.id}
                                                        >
                                                            <TableCell
                                                                component="th"
                                                                scope="row"
                                                            >
                                                                <Link
                                                                    component="button"
                                                                    variant="body2"
                                                                    onClick={() => {
                                                                        navigateToCertificate(
                                                                            certificate.id,
                                                                        );
                                                                    }}
                                                                >
                                                                    {
                                                                        certificate.referenceCode
                                                                    }
                                                                </Link>
                                                            </TableCell>
                                                            <TableCell>
                                                                {dayjs(
                                                                    certificate.dateFrom,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {dayjs(
                                                                    certificate.dateTo,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {t(
                                                                    certificate.status,
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ),
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Collapse>
                        </Box>
                    </Box>
                )}
            </Box>
            {user && (
                <OutOfServiceModal
                    open={openOOS}
                    onClose={(event: any, reason: string) => {}}
                    handleClose={handleCloseOOS}
                    user={user}
                    updateUser={setUser}
                />
            )}
        </Box>
    );
};

export default UserDetails;
